var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',{staticClass:"mb-4",attrs:{"outlined":""}},[_c('v-card-title',[_vm._v("Pesuaineen kulutus")]),_c('v-card-text',[_c('canvas',{ref:"chartCanvas"})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }